export default __webpack_public_path__ + "static/media/run.93fd517f.gif";